/**
 * Update profile to get new status from user
 * @returns Promise
 */
export const updateProfile = async () => fetch('/api/protected/profile');
